export const SENTRY_RELEASE = "local";
